import { useContext } from 'react';
import { AppContext } from './all';

type Unlocker = {
    id: number;
    [key: string]: any;
};

type Props = {
    unlocker: Unlocker;
};

export function SttQR({ unlocker }: Props): React.ReactElement {
    const cxt = useContext(AppContext)!;

    // -----| Render |-----
    return (
        <img
            style={{
                maxWidth: 300,
            }}
            width="100%"
            src={cxt?.getResource(`/unlockers/${unlocker.id}.svg`)}
        />
    );
}
